import type { RouteLocationNamedRaw, RouteLocationNormalized } from 'vue-router'

import type { useAuthStore } from '@/auth/useAuthStore'
import { checkACL, checkRole, checkScopes } from '@/utils/acl'

/**
 * V1 permission checking logic
 * Used as fallback when Authorizer is unavailable
 * @param to
 * @param authStore
 */
export const checkPermissionsV1 = (
  to: RouteLocationNormalized,
  authStore: ReturnType<typeof useAuthStore>
): RouteLocationNamedRaw | undefined => {
  const scope = authStore.scopes
  const userAcl = authStore.acl
  const role = authStore.role

  const { meta } = to

  if (meta.roles) {
    if (!role || !checkRole(role, meta.roles)) {
      return authStore.home
    }
  }

  if (meta.scopes) {
    if (!checkScopes(scope, meta.scopes)) {
      return authStore.home
    }
  }

  if (meta.acl) {
    const aclParams = Object.entries(meta.acl).reduce(
      (acc, [collection, routeParam]) =>
        Object.assign(acc, { [collection]: to.params[routeParam] }),
      {}
    )

    if (!checkACL(userAcl, aclParams)) {
      return authStore.home
    }
  }
}
